let formOverlay = document.querySelector(".formOverlay");
let form = document.querySelector(".form");
let formClose = document.querySelector(".form__close");
let formElement = document.querySelector(".form__form");

let headerOpenModalLinks = document.querySelectorAll(".header__openModal");
let aboutCta = document.querySelector(".aboutMD__cta");

let doctorCta = document.querySelectorAll(".doctorPG__topCta, .doctorPG__cta");

let cabinetCta = document.querySelectorAll(".cabinetPG__mainCtaBtn, .cabinetPG__cta");

if (formOverlay) {
	formOverlay.addEventListener("click", () => {
		document.body.classList.remove("scrollOff");
		formOverlay.classList.remove("formOverlay--visible");
		form.classList.remove("form--visible");
		form.style.setProperty("--bg", "");
	});
}

if (formClose) {
	formClose.addEventListener("click", () => {
		document.body.classList.remove("scrollOff");
		formOverlay.classList.remove("formOverlay--visible");
		form.classList.remove("form--visible");
		form.style.setProperty("--bg", "");
	});
}

if (headerOpenModalLinks.length) {
	headerOpenModalLinks.forEach((item) => {
		item.addEventListener("click", (evt) => {
			evt.preventDefault();
			document.body.classList.add("scrollOff");

			formOverlay.classList.add("formOverlay--visible");
			form.classList.add("form--visible");

			form.querySelector(".form__heading span").innerText = form.dataset.common;
		});
	});
}

if (aboutCta) {
	aboutCta.addEventListener("click", (evt) => {
		evt.preventDefault();
		document.body.classList.add("scrollOff");

		formOverlay.classList.add("formOverlay--visible");
		form.classList.add("form--visible");

		form.querySelector(".form__heading span").innerText = form.dataset.common;
	});
}

doctorCta.forEach((item) => {
	item.addEventListener("click", (evt) => {
		evt.preventDefault();
		document.body.classList.add("scrollOff");

		formOverlay.classList.add("formOverlay--visible");
		form.classList.add("form--visible");

		form.querySelector(".form__heading span").innerText = `${form.dataset.doctor} (${document.querySelector(".doctorPG__name").innerText})`;
	});
});

cabinetCta.forEach((item) => {
	item.addEventListener("click", (evt) => {
		evt.preventDefault();
		document.body.classList.add("scrollOff");

		formOverlay.classList.add("formOverlay--visible");
		form.classList.add("form--visible");

		form.querySelector(".form__heading span").innerText = `в ${document.querySelector(".cabinetPG__heading").innerText}`;

		form.style.setProperty("--bg", document.querySelector(".cabinetPG").style.getPropertyValue("--color"));
	});
});

if (form && formElement) {
	formElement.addEventListener("submit", (evt) => {
		evt.preventDefault();

		form.classList.add("form--waiting");

		sendData(formElement)
			.then((res) => res.json())
			.then((data) => {
				form.classList.remove("form--waiting");

				if (data == 1) {
					form.classList.add("form--success");
					window.dispatchEvent(new Event("formSubmitted"));
					setTimeout(() => {
						form.classList.remove("form--visible");
						formOverlay.classList.remove("formOverlay--visible");
					}, 1500);
				} else {
					form.classList.add("form--error");
				}

				setTimeout(() => {
					form.classList.remove("form--success");
					form.classList.remove("form--error");
				}, 1500);
			});
	});
}
